<template>
    <div class='business-equipmentlist'>
        <h2 class="top-title">{{title}}</h2>
        <!-- <Card dis-hover> -->
        <!-- v-if='dataLists.length' -->
        <div class="lists clearfix list-margin">
            <div v-html="htmlData"></div>
        </div>
        <!-- </Card> -->

      
    </div>
</template>
  
  <script>
import api from "@/api";

import ls from "store2";

export default {
    name: "viewxie",
 
    computed: {},
   
    data() {
        return {
            title: "",
            htmlData:""
        };
    },
    created() {},
    mounted() {
      this.init()
    },
    methods: {
     init(){
        let item=ls.get("useitem")
        this.title=item.title
        this.htmlData=item.content
         this.$store.state.spinShow = false;

     }
    },
};
</script>
  
  <style lang='less' scoped>
.business-equipmentlist {
    .lists {
        margin-top: 20px;
    }
}

</style>
<style>
.ivu-modal-confirm-head{
    display: flex !important;
}
.ivu-modal-confirm-head-title{
    padding-top: 8px;
}
.comment{
    white-space: pre-wrap;
}


</style>